import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthFacade } from '../facade/auth.facade';
import { Authentication } from '../models/authentication.model';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  constructor(private authFacade: AuthFacade, private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | boolean | UrlTree {
    const user: Partial<Authentication> = JSON.parse(this.authFacade.getLocalStorageData('userData'));
    if (user) {
      return true;
    } else {
      this.authFacade.resetStates();
      this.router.navigate(['auth/login']);
    }
  }
}
